<template>
  <div class="home">
    <IntroSection/>
  </div>
</template>

<script>
import IntroSection from '@/components/IntroSection.vue'

export default {
  name: 'HomeView',
  components: {
    IntroSection
  }
}
</script>
